var http = require('http');

var https = module.exports;

for (var key in http) {
    if (http.hasOwnProperty(key)) https[key] = http[key];
};

https.request = function (params, cb) {
    if (!params) params = {};
    params.scheme = 'https';
    params.protocol = 'https:';
    return http.request.call(this, params, cb);
}



//////////////////
// WEBPACK FOOTER
// ./~/https-browserify/index.js
// module id = 2357
// module chunks = 0